"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setup = exports.getHttpApi = exports.init = void 0;
var browser_1 = require("@cian/logger/browser");
var browser_2 = require("@cian/config/browser");
var browser_3 = require("@cian/telemetry/browser");
var shared_1 = require("@cian/peperrors/shared");
var HttpApi_1 = require("./internal/HttpApi/HttpApi");
var TelemetryHook_1 = require("../shared/internal/Hooks/TelemetryHook");
var CircuitBreakerHook_1 = require("../shared/internal/Hooks/CircuitBreakerHook");
var CancellationTokenHook_1 = require("../shared/internal/Hooks/CancellationTokenHook");
var BadStatusCodeHook_1 = require("../shared/internal/Hooks/BadStatusCodeHook");
var httpApi;
var httpApiSetupSettings;
var setup = function (settings) {
    httpApiSetupSettings = settings;
};
exports.setup = setup;
var init = function () {
    if (httpApi) {
        return httpApi;
    }
    (0, browser_1.init)();
    var telemetry = (0, browser_3.init)();
    var config = (0, browser_2.init)();
    var internalHttpApi = new HttpApi_1.HttpApi(httpApiSetupSettings);
    internalHttpApi.addHook(function (params) { return new TelemetryHook_1.TelemetryHook(Object.assign({ telemetry: telemetry }, params)); });
    if (config.get('http.browser.cb-enabled')) {
        internalHttpApi.addHook(function (params) { return new CircuitBreakerHook_1.CircuitBreakerHook(params); });
    }
    internalHttpApi.addHook(function (params) { return new CancellationTokenHook_1.CancellationTokenHook({ token: params.context.cancellationToken }); });
    internalHttpApi.addHook(function (params) { return new BadStatusCodeHook_1.BadStatusCodeHook(params); });
    httpApi = internalHttpApi;
    return httpApi;
};
exports.init = init;
var getHttpApi = function () {
    if (!httpApi) {
        throw new shared_1.ConfigurationError({
            message: 'HttpApi not initialized yet, call init function first',
            domain: 'http-api.getHttpApi',
        });
    }
    return httpApi;
};
exports.getHttpApi = getHttpApi;
//# sourceMappingURL=interface.js.map